import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './styles/mobile-utilities.css';
import App from './App.jsx';
import { initMobileOptimizations } from './utils/mobileHelpers';

// Initialize mobile optimizations
initMobileOptimizations();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
